import React, { useState } from 'react';
import Box from '@mui/material/Box';
import '../../common/pillTabs.css';
import OpenTicket from './OpenTicket';
import ClosedTicket from './ClosedTicket';
import AllSuportChat from './AllSuportChat';

const TABS = ['All Tickets', 'Open', 'Closed'];

const HelpAndSupport = () => {
  const [active, setActive] = useState(0);

  return (
    <Box>
      <Box sx={{ mb: 2.5 }}>
        <div className="pill-box" style={{ width: 340 }}>
          <div
            className="pill-slider"
            style={{
              left:  `calc(5px + ${active} * (100% - 10px) / 3)`,
              width: 'calc((100% - 10px) / 3)',
            }}
          />
          {TABS.map((label, i) => (
            <button
              key={label}
              className={`pill-btn${active === i ? ' active' : ''}`}
              onClick={() => setActive(i)}
            >
              {label}
            </button>
          ))}
        </div>
      </Box>

      {active === 0 && <AllSuportChat />}
      {active === 1 && <OpenTicket />}
      {active === 2 && <ClosedTicket />}
    </Box>
  );
};

export default HelpAndSupport;
